<template>
  <div style="width:100vw;overflow:hidden">
    
  <el-carousel :interval="5000" arrow="never" height="600px" style="position: relative;"ref="slideCarousel">
    <img class="imgtitle" :src="imgtitle" alt="">
    <el-carousel-item v-for="(image, index) in images" :key="index">
      <img style="height: 80vh;width: 100vw;" :src="image" alt="Carousel Image" />
    </el-carousel-item>
  </el-carousel>


  <div class="logo-title">
    <div class="logo-title-img"><img :src="logtitle.imgtitlelgo" alt=""></div>
    <div class="logo-title-title"><span>{{ logtitle.titletitle }}</span></div>
  </div>

  <!-- 滚动轮播 -->
  <div class="fu">
    <div class="swiper-container" id="swiper-container2">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in items2" :key="index">
          <img :src="item.image" alt="slide image" style="max-width: 100%; max-height: 100%;">
        </div>
      </div>


      <!-- 分页器 -->
      <div class="swiper-pagination"></div>
    </div>
  </div>

<!-- 轮播3 -->
<el-carousel class="custom-carousel" :interval="5000" arrow="never" height="65.7vh" ref="slideCarousel2">
    <el-carousel-item v-for="(item,index) in items3" :key="index">
      <img style="width: 100vw;height: auto;" :src="item.image" alt="">
    </el-carousel-item>
  </el-carousel>

  <!-- 垂直排版的图文模块 -->
   <div class="news" style="display: flex; flex-direction: column; align-items: center; gap: 2vh;margin-top: 7vh;">
    <!-- 使用 v-for 遍历 items 数组 -->
      <div v-for="(item, index) in items4" :key="index"  style="width:85vw;height:20vh; position: relative;">
        <img style="height:auto;width:85vw;border-radius:2px; box-shadow: 0 1px 5px 1px rgba(0, 0, 0, 0.2);" :src="item.imageSrc" alt="">
        <span style="position: absolute; top: 4vh; left: 10vw;font-size: 1.2rem;font-weight: 300;" :style="{color: item.color}"> {{ item.title }}</span>
        <button class="styled-button" @click="openwebtowx(item.link)">Click to view</button>
      </div>
   </div>

   <!-- 底部说明 -->
   <!-- <div class="footer">
  <div class="footer-container">
    <div class="footer-container-itme" >
    <div class="footer-container-contenone">
      <ul class="footer-container-contenone-ul">
        <li>公安备案号11010502030000</li>
        <li>京ICP备19000000号</li>
      </ul>
    </div>
    <div class="footer-container-logo">
      <img style="height: 100%" src="@/assets/bottombaner.jpg">
    </div>
    <div class="footer-container-contenthree">
      <ul class="footer-container-contenthree-ul">
        <li>营业执照</li>
        <li @click="showPicker = true">选择语言</li>
      </ul>
    </div>
  </div>
</div>
</div> -->

<van-popup
          v-model="showPicker"
          position="bottom"
          :overlay="true"
          class="popup-picker"
  >
    <van-picker
            title="Please select a language"
            show-toolbar
            :columns="columns"
            :default-index="0"
            @confirm="onConfirm"
            @cancel="onCancel"
            @change="onChange"
            confirm-button-text="confirm"
            cancel-button-text="cancel"
    />
  </van-popup>

  <div class="bottom2" style="position:relative;margin-top:6vh;">
      <img style="width:100vw;height:auto;" src="@/assets/bottom2.png"></img>

      <div class="bottom2-span">

        <div class="bottom2-span-one">
      <ul class="">
        <li>{{bottomh5.icpshort}}</li>
        <li style="position: relative;"  @click="goToLink(bottomh5.icplong)"><img style="position: absolute; height: auto;width:10px;left:-12px" src="@/assets/gongan.png">{{bottomh5.icplong}}</li>
      </ul>
    </div>

    <div class="bottom2-span-toow">
      <ul class="">
        <li @click="tolicece(bottomh5.licence.link)">{{bottomh5.licence.licencetext}}</li>
        <li @click="showPicker = true">Select a language</li>
      </ul>
    </div>

    </div>

  </div>

  <bottomh5 style="margin-top: 1vh;"></bottomh5>
</div>
</template>

<script>
 import bottomh5 from'@/view/h5/public/bottomh5en.vue'

 import Swiper, { Pagination, Autoplay, Navigation } from 'swiper'; // 导入 Swiper 和相关模块
 import 'swiper/css/swiper.min.css' // 注意这里的引入
 import axios from 'axios';
 import apiUrls from '@/http/http'; //  http.js 在 src/http 目录下
export default {
  components:{
          bottomh5
        },
  data() {
    return {
      // bottomh5:{
      //     icpshort:'京ICP备19000000号',
      //     icplong:'公安备案号11010502030000',
      //     licence:{link:'https://baidu.com',licencetext:'营业执照'}
      // },
      // //轮播图上的logo
      // imgtitle: require('@/assets/logo1.png'),
      // logtitle:{
      //   //图案logo
      //   imgtitlelgo: require('@/assets/logotuteng.png'),
      //   titletitle: "Business Travel Products & Seryice for Scenario Applicatio",
      //   titletitleen: "商务旅行场景应用产品服务"
      // },
     
      // // 首页轮播图片数组
      // images: [
      //   require('@/assets/First picture1.png'),
      //   require('@/assets/First picture2.png'),
      //   require('@/assets/First picture4h5.png'),
      //   require('@/assets/First picture3h5.png'),
      // ],
      // items2: [
      
      //   { image: require('@/assets/itme2h5.png'), title: 'Card 2', description: 'Description for card 2' },
      //   { image: require('@/assets/itme3h5.png'), title: 'Card 3', description: 'Description for card 3' },
      //   { image: require('@/assets/item4h5.png'), title: 'Card 4', description: 'Description for card 4' },
      //   { image: require('@/assets/ssss.png'), title: 'Card 4', description: 'Description for card 4' },
      //   { image: require('@/assets/itme5h5.png'), title: 'Card 4', description: 'Description for card 4' },
      //   { image:  require('@/assets/itme1h5.png'), title: 'Card 1', description: 'Description for card 1' },
      // ],
      // items3: [
      
      //   { image: require('@/assets/itme6h5.png'), title: 'Card 2', description: 'Description for card 2' },
      //   { image: require('@/assets/lunbo3h52.png'), title: 'Card 3', description: 'Description for card 3' },
      //   { image: require('@/assets/lunboh523.png'), title: 'Card 4', description: 'Description for card 4' },
      // ],
      // items4: [
      //   {
      //     imageSrc: require('@/assets/pic-R&D banner.png'),
      //     altText: 'R&D Banner Image',
      //     title: 'Brand Story',
      //     buttonText: 'Click to view',
      //     link:'https://mp.weixin.qq.com/s/THrkCe6eUwqH2VXpBSTHNA',
      //     color:'black'
      //   },
      //   {
      //     imageSrc: require('@/assets/banner3-18-18-18.png'),
      //     altText: 'R&D Banner Image',
      //     title: 'Independently Developed',
      //     buttonText: 'Click to view',
      //     link:'https://mp.weixin.qq.com/s/ArXzvW-GcyizpM635Xl71Q',
      //     color:'white'
      //   },
      //   {
      //     imageSrc: require('@/assets/banner3-19-19.jpg'),
      //     altText: 'R&D Banner Image',
      //     title: 'Environmental Protection',
      //     buttonText: 'Click to view',
      //     link:'https://mp.weixin.qq.com/s/29Ot_8msz3966GXyJrvVMA',
      //     color:'white'
      //   },
      //   {
      //     imageSrc: require('@/assets/banner3-11-11-11.png'),
      //     altText: 'R&D Banner Image',
      //     title: 'Exhibition Center',
      //     buttonText: 'Click to view',
      //     link:'https://mp.weixin.qq.com/s/Or1JNVZD9N9ndPU_MvSClw',
      //     color:'white'
      //   },
       
      // ],

      // columns: ['CN', 'EN'],
      //   columnsen: ['CN', 'EN'],
      //   showPicker: false, // 控制弹出层的显示与隐藏


          // _______________________________________________
      loading: true,
     loading2: true,
    bottomh5: {
      icpshort: '',
      icplong: '',
      licence: {
        link: '',
        licencetext: ''
      }
    },
    imgtitle: '',
    logtitle: {
      imgtitlelgo: '',
      titletitle: '',
      titletitleen: ''
    },
    // 首页轮播图片数组
    images: [],
    // items2, items3, items4等保持结构
    items2: [
      { image: '', title: '', description: '' },
      { image: '', title: '', description: '' },
      { image: '', title: '', description: '' },
      { image: '', title: '', description: '' },
      
    ],
    items3: [
      { image: '', title: '', description: '' },
      { image: '', title: '', description: '' },
      { image: '', title: '', description: '' },
    ],
    items4: [
      {
        imageSrc: '',
        altText: '',
        title: '',
        buttonText: '',
        link: '',
        color: ''
      },
      {
        imageSrc: '',
        altText: '',
        title: '',
        buttonText: '',
        link: '',
        color: ''
      },
      {
        imageSrc: '',
        altText: '',
        title: '',
        buttonText: '',
        link: '',
        color: ''
      },
      {
        imageSrc: '',
        altText: '',
        title: '',
        buttonText: '',
        link: '',
        color: ''
      },
    ],
    columns: ['CN', 'EN'],
        columnsen: ['CN', 'EN'],
        showPicker: false, // 控制弹出层的显示与隐藏
    };
  },
  mounted() {
  //   this.$nextTick(() => {
  //   this.lunbo(); // 确保在 DOM 更新后执行 Swiper 初始化

  //   //调用手指滑动轮播
	// this.slideBanner();
  //   //调用手指滑动轮播
	// this.slideBanner2();


  // });

  // this.fetchData();
  },
  created(){
    this.fetchData();
  },
  methods:{
    tolicece(itme){
      window.location.href = itme;
    },
    goToLink(itme) {
    window.location.href = `https://beian.mps.gov.cn/#/query/webSearch?code=${itme}`;  // 直接跳转
  },

    async fetchData() {
            try {
                // 发起 API 请求
                const response = await axios.get(`${apiUrls.baseUrl}/website/api/Indexmainh5`);
                const data = response.data;
                // console.log(data)
                if (data && data.length > 0) {
                   
                  this.assignData(data)
                   
                }
            } catch (error) {
                 // 如果后台返回空数据，则使用默认数据
                this.assignDefaultData();
              console.error('后台请求失败，使用默认数据:', error);
            }
        }, 
 /**
 * 逐个赋值数据
 * @param {Array} data - 要赋值的数据数组
 * @param {number} interval - 赋值的时间间隔，默认为 1000 毫秒（1秒）
 */
 assignData(data, interval = 10) {
   
   // 定义赋值的步骤
   const steps = [
          () => {
           this.imgtitle= `${apiUrls.devApi}${data[0].imgtitle}`;
           const imagePaths=data[0].images.split(',');
          // 处理 imagePaths，生成完整的图片路径
          this.images = imagePaths.map(path => `${apiUrls.baseUrl}${path}`);
  
         const imgpath2= data[0].items2image.split(',');
  
            // 更新 items2 中的图片路径
            imgpath2.forEach((path, index) => {
                // 使用映射的路径更新 items2 中对应项的 image
                if (this.items2[index]) {
                    this.items2[index].image = `${apiUrls.baseUrl}${path}`;
                }
            });
            this.$nextTick(() => {
              this.lunbo(); // 确保在 DOM 更新后执行 Swiper 初始化

              //调用手指滑动轮播
            this.slideBanner();
              //调用手指滑动轮播
            this.slideBanner2();
            });
  
            this.logtitle.imgtitlelgo=`${apiUrls.baseUrl}${ data[0].imgtitlelgo}`;
         this.logtitle.titletitle=data[0].titletitleen
          },
          () => {
              const imgpaht3=data[0].items3image.split(',');
                // 更新 items2 中的图片路径
                imgpaht3.forEach((path, index) => {
                              // 使用映射的路径更新 items2 中对应项的 image
                              if (this.items3[index]) {
                                  this.items3[index].image = `${apiUrls.baseUrl}${path}`;
                              }
                          });
  
              // console.log(imgpaht3)
          },
          ()=>{
                          // 更新 items4 数组
                data.forEach((item, index) => {
                    if (this.items4[index]) {
                        // 更新 imageSrc
                        this.items4[index].imageSrc = `${apiUrls.baseUrl}${item.items4imageSrc}`;
                        // 更新其他字段
                        this.items4[index].altText = item.items4altTexttitleen;
                        this.items4[index].title = item.items4altTexttitleen;
                        this.items4[index].link = item.items4link;
                        this.items4[index].color = item.items4color || 'white'; // 默认白色
                    }
                });
          },
          ()=>{
              // 赋值操作
              this.bottomh5.icpshort = data[0].bottomh5icpshort;
              this.bottomh5.icplong = data[0].bottomh5icplong;
              this.bottomh5.licence.link = data[0].bottomh5licencelink;
              this.bottomh5.licence.licencetext = data[0].bottomh5licencelicencetexten;
          }
          ];
  
          let index = 0;
         // 执行每个步骤，每个步骤间隔 interval 毫秒
         const executeStep = () => {
          if (index < steps.length) {
              steps[index]();  // 执行当前步骤
              index++;
  
              // 继续执行下一步
              setTimeout(executeStep, interval);  // 等待指定间隔后继续执行下一步
          }
      };
  
      // 启动第一次赋值操作
      executeStep();
  },
/**
     * 赋值默认静态数据（仅在后台请求失败时调用）
     */
     assignDefaultData() {
      // 轮播图 logo
      this.imgtitle = require('@/assets/logo1.png');
      // logo 和标题
      this.logtitle = {
        imgtitlelgo: require('@/assets/logotuteng.png'),
        titletitle: "商务旅行场景应用产品服务",
        titletitleen: "商务旅行场景应用产品服务"
      };
      // 首页轮播图片
      this.images = [
        require('@/assets/First picture1.png'),
        require('@/assets/First picture2.png'),
        require('@/assets/First picture4h5.png'),
        require('@/assets/First picture3h5.png')
      ];
      // items2 轮播
      this.items2 = [
        { image: require('@/assets/itme2h5.png'), title: 'Card 2', description: 'Description for card 2' },
        { image: require('@/assets/itme3h5.png'), title: 'Card 3', description: 'Description for card 3' },
        { image: require('@/assets/item4h5.png'), title: 'Card 4', description: 'Description for card 4' },
        { image: require('@/assets/ssss.png'), title: 'Card 4', description: 'Description for card 4' },
        { image: require('@/assets/itme5h5.png'), title: 'Card 4', description: 'Description for card 4' },
        { image: require('@/assets/itme1h5.png'), title: 'Card 1', description: 'Description for card 1' },
      ];
      // items3 轮播
      this.items3 = [
        { image: require('@/assets/itme6h5.png'), title: 'Card 2', description: 'Description for card 2' },
        { image: require('@/assets/lunbo3h52.png'), title: 'Card 3', description: 'Description for card 3' },
        { image: require('@/assets/lunboh523.png'), title: 'Card 4', description: 'Description for card 4' },
      ];
      this.$nextTick(() => {
              this.lunbo(); // 确保在 DOM 更新后执行 Swiper 初始化

              //调用手指滑动轮播
            this.slideBanner();
              //调用手指滑动轮播
            this.slideBanner2();
            });
      // items4 图文模块
      this.items4 = [
        {
          imageSrc: require('@/assets/pic-R&D banner.png'),
          altText: 'R&D Banner Image',
          title: '品牌故事',
          buttonText: '点击查看',
          link: 'https://mp.weixin.qq.com/s/THrkCe6eUwqH2VXpBSTHNA',
          color: 'black'
        },
        {
          imageSrc: require('@/assets/banner3-18-18-18.png'),
          altText: 'R&D Banner Image',
          title: '自主研发',
          buttonText: '点击查看',
          link: 'https://mp.weixin.qq.com/s/ArXzvW-GcyizpM635Xl71Q',
          color: 'white'
        },
        {
          imageSrc: require('@/assets/banner3-19-19.jpg'),
          altText: 'R&D Banner Image',
          title: '绿色环保',
          buttonText: '点击查看',
          link: 'https://mp.weixin.qq.com/s/29Ot_8msz3966GXyJrvVMA',
          color: 'white'
        },
        {
          imageSrc: require('@/assets/banner3-11-11-11.png'),
          altText: 'R&D Banner Image',
          title: '展示中心',
          buttonText: '点击查看',
          link: 'https://mp.weixin.qq.com/s/Or1JNVZD9N9ndPU_MvSClw',
          color: 'white'
        },
      ];
      // 底部信息
      this.bottomh5 = {
        icpshort: '京ICP备19000000号',
        icplong: '公安备案号11010502030000',
        licence: { link: 'https://baidu.com', licencetext: '营业执照' }
      };
      // 请求结束后关闭加载动画
      this.loading = false;
      this.loading2 = false;
    },
    openwebtowx(iemt){
        window.location.href=iemt;
    },
  /**
   * elemeui手指滑动轮播
   */
	slideBanner() {
	  //选中的轮播图
	  var box = document.querySelector('.el-carousel__container');
	  var startPoint = 0;
	  var stopPoint = 0;
	  //重置坐标
	  var resetPoint = function () {
	    startPoint = 0;
	    stopPoint = 0;
	  }
	  //手指按下
	  box.addEventListener("touchstart", function (e) {
	    //手指点击位置的X坐标
	    startPoint = e.changedTouches[0].pageX;
	  });
	  //手指滑动
	  box.addEventListener("touchmove", function (e) {
	    //手指滑动后终点位置X的坐标
	    stopPoint = e.changedTouches[0].pageX;
	  });
	  //当手指抬起的时候，判断图片滚动离左右的距离
	  let that = this
	  box.addEventListener("touchend", function (e) {
	    // console.log("1：" + startPoint);
	    // console.log("2：" + stopPoint);
	    if (stopPoint == 0 || startPoint - stopPoint == 0) {
	      resetPoint();
	      return;
	    }
	    if (startPoint - stopPoint > 0) {
	      resetPoint();
	      that.$refs.slideCarousel.next();
	      return;
	    }
	    if (startPoint - stopPoint < 0) {
	      resetPoint();
	      that.$refs.slideCarousel.prev();
	      return;
	    }
	  });
	},
 /**
   * elemeui手指滑动轮播
   */
   slideBanner2() {
	  //选中的轮播图
	  var box = document.querySelector('.custom-carousel');
	  var startPoint = 0;
	  var stopPoint = 0;
	  //重置坐标
	  var resetPoint = function () {
	    startPoint = 0;
	    stopPoint = 0;
	  }
	  //手指按下
	  box.addEventListener("touchstart", function (e) {
	    //手指点击位置的X坐标
	    startPoint = e.changedTouches[0].pageX;
	  });
	  //手指滑动
	  box.addEventListener("touchmove", function (e) {
	    //手指滑动后终点位置X的坐标
	    stopPoint = e.changedTouches[0].pageX;
	  });
	  //当手指抬起的时候，判断图片滚动离左右的距离
	  let that = this
	  box.addEventListener("touchend", function (e) {
	    // console.log("1：" + startPoint);
	    // console.log("2：" + stopPoint);
	    if (stopPoint == 0 || startPoint - stopPoint == 0) {
	      resetPoint();
	      return;
	    }
	    if (startPoint - stopPoint > 0) {
	      resetPoint();
	      that.$refs.slideCarousel2.next();
	      return;
	    }
	    if (startPoint - stopPoint < 0) {
	      resetPoint();
	      that.$refs.slideCarousel2.prev();
	      return;
	    }
	  });
	},

    lunbo(){
      
      // 初始化 Swiper
    new Swiper('#swiper-container2', {
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,// 用户操作后是否停止自动播放，默认为true
        pauseOnMouseEnter: true,// 鼠标悬停时暂停自动播放
        stopOnLastSlide: false,// 到达最后一张幻灯片后是否停止自动播放
        reverseDirection: false,// 是否反向播放
      },
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      slidesPerView: 1.8,
      centeredSlides: true,
      spaceBetween: 3,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets', // 设置分页器类型为子弹点
        clickable: true, // 允许点击分页器切换幻灯片
        bulletClass: 'swiper-pagination-bullet', // 使用 Swiper 5 的默认分页器子弹点类
        bulletActiveClass: 'swiper-pagination-bullet-active' // 自定义活动子弹点类名
      },
    });
    },
    onConfirm(value, index) {
    // alert(`当前值：${value}, 当前索引：${index}`);
    
    // 确保使用 this.$route.name 获取当前路由名称
    if (value === 'EN' && this.$route.name !== 'indexmainh5en') {
        this.$router.push({ name: 'indexmainh5en' }); // 使用命名路由
    }else if(value === 'CN' && this.$route.name !== 'indexmainh5'){
      this.$router.push({ name: 'indexmainh5' }); // 使用命名路由
    }
    
    this.showPicker = false; // 确认后关闭弹出层
},
      onChange(picker, value, index) {
        // console.log('onChange:', picker, value, index);
      },
      onCancel() {
        this.showPicker = false; // 取消后关闭弹出层
      },
  }
};
</script>

<style scoped>
/deep/.el-menu{
  padding-left:3.5vw;
}
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  width: 100vw;
  overflow-x: hidden;  /* 防止横向滚动 */
}
.van-popup {
  max-width: 100vw;
  width: 100vw;
  overflow: hidden;
}


/**按钮样式*/
.styled-button {
    position: absolute;
    top: 12vh; /* 调整到你想要的位置 */
    left: 10vw; /* 调整到你想要的位置 */
    width: 20vw;
    height: 7vw; /* 使宽度和高度相等以保持圆形 */
    background: #fff;
    border: 3px solid #ccc; /* 灰色边框 */
    border-radius:50px; /* 圆形边框 */
    
    color: rgb(159, 155, 155); /* 白色文字 */
    font-size: 1vh; /* 文字大小可以根据需要调整 */
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    cursor: pointer;
  }

.imgtitle{
  position: absolute; height: 2vh;top: 7vh;left: 44vw; z-index: 9;
}
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  .el-carousel__item img {
  max-width: 100vw;  /* 确保图片不超过视口宽度 */
}

.el-carousel-item img {
 
  max-width: 100vw;
}
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  /deep/ .el-carousel__indicator--horizontal .el-carousel__button {
    width: 0.5rem;
    height:  0.5rem;
    background: transparent;
    border: 1px solid #ffffff;
    border-radius: 50%;
    opacity: 0.5;
  }  
  /deep/ .el-carousel__indicator--horizontal.is-active .el-carousel__button{
    width:  0.5rem;
    height:  0.5rem;
    background: #ffffff;
    border-radius: 50%;
    opacity: 1;
  }


  .logo-title{
    /* height: 20vh; */
    display: flex;
    flex-direction: column; /* 使图标和文本垂直排列 */
    align-items: center;    /* 使图标和文本水平居中 */
    margin-top: 3vh;
    width: 100vw;  /* 确保容器宽度不会超出视口 */
  }
  .logo-title-title{
      width: 100%;
      display: flex;            /* 使用 flexbox 布局 */
    justify-content: center;  /* 水平居中 */
    align-items: center;      /* 垂直居中 */


}

  
  .logo-title-title span{
    font-size: 0.85rem;
    line-height:5vh;


  
  }
  .logo-title-img{
    width: 100%;
    padding: 0;
    display: flex;            /* 使用 flexbox 布局 */
    justify-content: center;  /* 水平居中 */
    align-items: center;      /* 垂直居中 */
  }
  .logo-title-img img{
    width: 8vw;
  }










  /* 轮播2 */
  .fu {
      display: flex;
      /* flex-direction: column; */
      justify-content: center;
      align-content: center;
      height: 42vh;
      margin-top: 5vh;
    }

    .swiper-container {
      width: 100vw;
      overflow: hidden;
    }

    .swiper-slide {
      /* 背景颜色可以根据需要调整 */
    }

    .swiper-slide img {
      width: 50vw;
      height: auto;
      transition: opacity 0.3s ease; /* 添加过渡效果 */
    }

    /* 定义分页器整体样式 */
    /deep/.swiper-pagination {
     
      position: absolute;
      bottom: 0; /* 设置分页器距离容器底部的距离 */
      left: 0;
      right: 0;
      text-align: center; /* 水平居中 */
      z-index: 10; /* 确保分页器在图片上层 */
    }
  
    /* 自定义子弹点样式 */
    /deep/.swiper-pagination-bullet {
      width: 8vw !important; /* 设置每个子弹点的宽度 */
      height: 0.3vh; /* 设置每个子弹点的高度 */
      display: inline-block;
      background: #ccc; /* 子弹点背景颜色 */
      opacity: 1; /* 不透明度 */
      border-radius: 0 !important; /* 移除圆角 */
      margin: 0 !important; /* 去掉间距，使子弹点紧密排列 */
    }

    /* 自定义激活子弹点样式 */
    /deep/.swiper-pagination-bullet-active {
      background: #010711 !important; /* 激活子弹点的颜色 */
    }

    /* 设置非活动幻灯片的透明度 */
    /deep/.swiper-slide:not(.swiper-slide-active) img {
      opacity: 0.5; /* 设置图片透明度 */
    }

    /* 确保活动幻灯片的图片不透明 */
    /deep/.swiper-slide-active img,
    .swiper-slide-active .swiper-lazy-loaded {
      opacity: 1;
    }
  /* 轮播2结束 */





  /* 轮播3 */
  .custom-carousel{
    margin-top: 7vh;
  }
 .custom-carousel ::v-deep .el-carousel__indicator--horizontal{
    padding: 0;
    /* display: inline-block; */
   
   
  }
  .custom-carousel ::v-deep .el-carousel__indicators--horizontal{
    bottom: 2vh;
  }
  .custom-carousel ::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
    width: 7vw; /* 设置每个子弹点的宽度 */
    height: 0.3vh; /* 设置每个子弹点的高度 */
    border-radius: 0;
    /* opacity: 0.1; */
    display: inline-block;
    background: #f7f6f6; /*子弹点背景颜色 */
    margin: 0;
    border: none;
}
.custom-carousel ::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  background: white; /* 激活子弹点的颜色 */
}
  /* 轮播3结束 */

  /* 底部说明 */
  .footer{
    margin-top:5vh;

      width: 100vw;
      height: 20vh;
      background: #fff;
    }
    .footer-container{
      height: 100%;
      width: calc(100vw-0.5rem);
      border-radius: 28px;
     background:#100f0f;
      border: 0.5rem solid #100f0f; /* 灰色边框 */

      display: flex;
      justify-content: center;
    }
    .footer-container-itme{
      height: 100%;
      border-radius: 28px;
      background: #2a2828;
      width:100%;

      display: flex;
      justify-content: center;
    }
.footer-container-contenone,
.footer-container-contenthree{
 
  height: 100%;
  width: 40%;

}
.footer-container-logo{
  height: 100%;
  width: 20%;


  display: flex; /* 使用 Flexbox 布局 */
  justify-content: center; /* 水平居中对齐 */
  align-items: center; /* 垂直居中对齐 */
}
.footer-container-contenone{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.footer-container-contenone-ul{
  list-style-type: none; /* 移除列表项符号 */
  padding: 0; /* 移除默认填充 */
  margin: 0; /* 移除默认外边距 */

  display: flex; /* 使用 Flexbox 布局 */
  flex-direction: column;
  justify-content: center; /* 水平居中对齐 */
  align-items: flex-start; /* 确保所有 li 起始位置一致 */

}
    .footer-container-contenone-ul li{
      font-size: 0.5rem;
      display: inline-block;/*同一行内显示*/
      white-space: nowrap; /*防止文本换行*/
      text-align: left; /* 让 li 内部文本左对齐 */
      color: white;
    }


    .footer-container-contenthree{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .footer-container-contenthree-ul{
      list-style-type: none; /* 移除列表项符号 */
      padding: 0; /* 移除默认填充 */
      margin: 0; /* 移除默认外边距 */

      display: flex; /* 使用 Flexbox 布局 */
      flex-direction: column;
      justify-content: center; /* 水平居中对齐 */
      align-items: flex-start; /* 确保所有 li 起始位置一致 */

    }
    .footer-container-contenthree-ul li{
      font-size: 0.5rem;
      display: inline-block;/*同一行内显示*/
      white-space: nowrap; /*防止文本换行*/
      text-align: left; /* 让 li 内部文本左对齐 */
      color: white;
    }
  /* 底部说明结束 */


  /* 尾部开始 */
.bottom2-span{
  position:absolute;
  top:12vh;
  

  width:100vw;
  display: flex;
  justify-content: space-between;
  gap:1px;
  font-size:0.6rem;
  color:white;
}
.bottom2-span .bottom2-span-one,
.bottom2-span .bottom2-span-toow{
  width:50%;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items: center; /* 确保所有 li 起始位置一致 */
}
.bottom2-span ul li{
 
}
  /* 尾部结束 */
</style>